import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    active: 'Active',
    cancelled: 'Cancelled',
    cancelScheduledTransfer: 'Cancel scheduled transfer',
    confirmCancellation: {
      cancel: 'Cancel',
      cancelScheduledTransferSuccess:
        'Your scheduled transfer has been cancelled',
      confirm: 'Confirm',
      nextOccurrencesCancel: 'The next occurrences will also be cancelled.',
      pendingTransfers:
        'Pending transfers will not be affected. You can cancel them directly in the Bank tab.',
      title: 'Are you sure you want to cancel this scheduled transfer?',
    },
    details: {
      amount: 'Amount',
      endDate: 'Cut-off date',
      frequency: 'Frequency',
      issuer: 'From your wallet',
      nextOccurrenceDate: 'Next due date',
      occurrence: '{remainingNumberOfOccurrences} occurrence',
      occurrences: '{remainingNumberOfOccurrences} occurrences',
      recipient: 'To your recipient',
      remainingNumberOfOccurrences: 'Remaining number of occurrences',
    },
    scheduledTransferDetails: 'Transfer details',
    toBeneficiary: 'To {beneficiary}',
  },
  fr: {
    active: 'Actif',
    cancelled: 'Annulé',
    cancelScheduledTransfer: 'Annuler le virement programmé',
    confirmCancellation: {
      cancel: 'Annuler',
      cancelScheduledTransferSuccess:
        'Votre virement programmé a bien été annulé',
      confirm: 'Confirmer',
      nextOccurrencesCancel:
        'Les prochaines échéances seront également annulées.',
      pendingTransfers:
        'Les virements déjà en attente ne seront pas affectés. Vous pouvez les annuler directement dans l’onglet Banque',
      title: 'Êtes-vous sûr·e de vouloir annuler ce virement programmé\xa0?',
    },
    details: {
      amount: 'Montant',
      endDate: 'Date limite',
      frequency: 'Fréquence',
      issuer: 'Depuis votre compte',
      nextOccurrenceDate: 'Date de la prochaine échéance',
      occurrence: '{remainingNumberOfOccurrences} occurrence',
      occurrences: '{remainingNumberOfOccurrences} occurrences',
      recipient: 'Vers votre bénéficiaire',
      remainingNumberOfOccurrences: 'Échéances restantes',
    },
    scheduledTransferDetails: 'Détails du virement',
    toBeneficiary: 'Vers {beneficiary}',
  },
} as const);

export default locales;
